export default __webpack_public_path__ + "static/media/Pricing.262e905f.webp";